'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarBannerSegmentImage = renderWithRef('PriceBarBannerSegmentImage', null, (n, a)=>jsx(RenderComp, {
        root: "img",
        forwardedRef: a,
        classNames: new Set([
            'swan-price-bar-banner-icon'
        ]),
        props: n
    }));

export { PriceBarBannerSegmentImage };
